module.exports = __webpack_public_path__ + "img/ugly_or_beuty_enterior.30bf9d37.jpg";